<template>
  <div class="audit-process">
    <HomeHeader scroll-top="300"></HomeHeader>
    <div class="container w-wrapper">
      <div class="back" @click="goBack()">返回MCN机构申请</div>
      <div class="title">审核进度查询</div>
      <div class="form-box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="ruleForm.phone" @blur="getImgVerifyCodeApi()" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="图形验证码" prop="code">
            <div class="flex-row-h-center">
              <div style="flex: 1;">
                <el-input v-model="ruleForm.code" maxlength="4" placeholder="请输入"></el-input>
              </div>
              <div style="width: 150px;margin-left: 10px;">
                <img
                    v-if="imgCodeUrl"
                    @click="getImgVerifyCodeApi()"
                    style="width: 100px;" :src="imgCodeUrl"
                    alt="">
                <span style="cursor: pointer;" @click="getImgVerifyCodeApi('toast')" v-else>请输入手机号码</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="短信验证码" prop="smsCode">
            <div class="flex-row-h-center">
              <div style="flex: 1;">
                <el-input v-model="ruleForm.smsCode" maxlength="6" placeholder="请输入"></el-input>
              </div>
              <div style="width: 150px;margin-left: 10px;">
                <el-button @click="getSMSVerifyCodeApi()">
                  {{ countdown > 0 ? `${countdown}秒后重试` : '获取短信验证码' }}
                </el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div style="margin-top: 40px">
              <el-button v-if="!isSubmit" style="width: 100%;" type="primary" @click="submitForm()">确认查询</el-button>
              <div v-if="isSubmit && (applyStatus === 0 || applyStatus === -1 || applyStatus === 4)">
                <el-button style="width: 40%;" type="default" @click="goBack()">返回</el-button>
                <el-button style="width: 40%;" type="primary" @click="goApply()">申请</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/views/home/components/home-header";
import {encryptECB} from '@/utils/parsing'
import {
  getImgVerifyCode,
  getSMSVerifyCode
} from "@/apis/audit";
import {joinApplyHistory} from "@/apis/audit";

export default {
  name: "audit-process",
  components: {
    HomeHeader
  },
  data() {
    return {
      countdown: 0, // 倒计时
      timer: null, // 定时器
      isSubmit: false, // 是否提交过
      applyStatus: '', // 申请状态 0-草稿 1-待审核 2-审核通过 3-审核失败 4-已退出
      colSpan: 14,
      imgCodeUrl: '', // 图形验证码
      imgKey: '', // 图形验证码的key
      smsCode: '', // 短信验证码
      smsKey: '', // 短信验证码的key
      ruleForm: {
        phone: '',
        code: '',
        smsCode: ''
      },
      rules: {
        phone: [
          {required: true, message: '请输入手机号码', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入图文验证码', trigger: 'blur'}
        ],
        smsCode: [
          {required: true, message: '请输入短信验证码', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    // 去申请页面
    goApply() {
      console.log(this.applyStatus)
      let path = '/apply/step-one'
      if (this.applyStatus === -1) {
        path = '/apply/select'
      }
      this.$router.push({
        path: path
      })
    },
    // 获取图文验证码
    getImgVerifyCodeApi(type) {
      if (!this.ruleForm.phone || this.ruleForm.phone.length < 11) {
        if (type === 'toast') {
          this.$message({
            message: '请输入正确的手机号码',
            type: 'warning'
          })
        }
        return
      }
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
      })
      getImgVerifyCode({
        phone: encryptECB(this.ruleForm.phone)
      }).then(res => {
        this.imgCodeUrl = res.data.code
        this.imgKey = res.data.key
      }).finally(() => {
        loading.close()
      })
    },
    // 获取短信验证码
    getSMSVerifyCodeApi() {
      if (!this.ruleForm.code) {
        return this.$message({
          message: '请输入图文验证码',
          type: 'warning'
        })
      }
      if (this.countdown > 0) return; // 防抖处理
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
      })
      getSMSVerifyCode({
        code: this.ruleForm.code,
        key: this.imgKey,
        isGetProgress: true,
        phone: encryptECB(this.ruleForm.phone)
      }).then((res) => {
        this.smsCode = res.data.code
        this.smsKey = res.data.key
        this.$message({
          message: '验证码已发送，请注意查收',
          type: 'success'
        });
        this.countdown = 60;
        this.timer = setInterval(() => {
          if (this.countdown <= 0) {
            clearInterval(this.timer);
          } else {
            this.countdown--;
          }
        }, 1000);
      }).catch(() => {
        this.countdown = 0;
      }).finally(() => {
        loading.close()
      })
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.joinApplyHistory()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    joinApplyHistory() {
      if (!this.smsKey) {
        return this.$message({
          message: '请先获取短信验证码',
          type: 'warning'
        })
      }
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        text: '拼命加载中...',
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'global-loading', // 设置最高层级，防止弹窗把loading覆盖
      })
      this.isSubmit = true
      joinApplyHistory({
        code: this.ruleForm.smsCode,
        key: this.smsKey,
        phone: encryptECB(this.ruleForm.phone)
      }).then(res => {
        const data = res.data || {}
        const status = data.status // 状态 0-草稿 1-待审核 2-审核通过 3-审核失败 4-已退出
        this.applyStatus = status
        if (!data.id) {
          return this.$message({
            message: data.message,
            type: 'warning'
          })
        }
        this.$store.commit('common/setToken', data.token)
        this.$store.commit('common/setApplyId', `${data.id}`)
        console.log(status)
        if (status === 0) {
          this.$message({
            message: '暂无申请记录，请重新申请',
            type: 'warning'
          })
        } else if (status === 1 || status === 3) {
          this.$router.push({
            path: '/apply/wait-audit',
            query: {
              status: status
            }
          })
        } else if (status === 2 || status === 4) {
          this.$router.push({
            path: '/apply/finish-enter',
            query: {
              status: status
            }
          })
        } else {
          this.$message({
            message: res.message,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.isSubmit = false
      }).finally(() => {
        loading.close()
      })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
  }
}
</script>

<style lang="scss" scoped>
.audit-process {
  overflow: hidden;
  height: 100vh;

  .container {
    position: relative;
    margin: 100px auto;
    height: calc(100% - 160px);
    padding: 30px;
    background-color: #ffffff;

    .back {
      position: absolute;
      top: 20px;
      left: 20px;
      color: #409EFF;
      cursor: pointer;
    }

    .title {
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 100px;
    }

    .form-box {
      flex: 1;
      overflow-y: auto;
      margin: 20px 0 0;
      padding: 30px 240px 20px;
    }
  }
}
</style>